import type { SpatialRectangle } from "../types/geometry/SpatialRectangle"

export const GetBleed = (
  media: SpatialRectangle,
  crop: SpatialRectangle
): number =>
  Math.max(
    media.x - crop.x,
    crop.x + crop.width - (media.x + media.width),
    media.y - crop.y,
    crop.y + crop.height - (media.y + media.height)
  )
